import type { ComponentType, LazyExoticComponent } from 'react';
import { appointmentsRoutes } from 'src/features/appointments/routes';
import { authRoutes } from 'src/features/auth/routes';
import { clientsRoutes } from 'src/features/clients/routes';
import { financeRoutes } from 'src/features/finance/routes';
import { homeRoutes } from 'src/features/home/routes';
import { scheduleRoutes } from 'src/features/schedule/routes';
import { servicesRoutes } from 'src/features/services/routes';

export interface AppRoute {
  path: string;
  name: string;
  element: ComponentType<unknown> | LazyExoticComponent<ComponentType<unknown>>;
}

// Add one import + one spread per feature. Nothing else in the shell changes.
export const routes: AppRoute[] = [
  ...homeRoutes,
  ...appointmentsRoutes,
  ...clientsRoutes,
  ...servicesRoutes,
  ...scheduleRoutes,
  ...financeRoutes,
  ...authRoutes,
];
